import { ValidationModalSection } from "~/models/navigableValidations/validationSections";
import VisualizationDataPointValidator from "../navigableValidators/visualizationDataPointValidator";
import VisualizationPublishedSourcesValidator from "../navigableValidators/visualizationPublishedSourcesValidator";
import Visualization from "../visualizations/visualization";
import NavigableValidation from "./navigableValidation";


export default class VisualizationBuilderValidation extends NavigableValidation<Visualization> {
  validators = [

    new VisualizationDataPointValidator({
      validatorKey: 'data_points',
      section: ValidationModalSection.DataPoints
    }),

    new VisualizationPublishedSourcesValidator({
      validatorKey: 'data_sources',
      section: ValidationModalSection.DataSources
    })

  ];
}